module.exports = __webpack_public_path__ + "img/104.4e64ea7f.jpg";